(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["table-list"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('table-list')) {
    class TableList extends HTMLElement {
      connectedCallback() {
        this.highlightToday();
      }

      highlightToday() {
        const timeZone = this.dataset.timezone;
        if (!timeZone) return;

        let weekday;
        try {
          weekday = new Intl.DateTimeFormat('en-US', {
            weekday: 'short',
            timeZone: timeZone === 'local' ? undefined : timeZone,
          }).format(new Date());
        } catch (error) {
          return;
        }

        const todayNumber = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].indexOf(weekday) + 1;

        this.querySelectorAll('.table-list__row.is-today').forEach((row) => row.classList.remove('is-today'));
        this.querySelectorAll('.table-list__today').forEach((badge) => badge.remove());

        // "~=" also matches grouped rows such as data-weekday="1 2 3 4 5" (opening hours from a metaobject).
        const row = this.querySelector(`.table-list__row[data-weekday~="${todayNumber}"]`);
        if (!row) return;

        row.classList.add('is-today');

        const label = this.dataset.todayLabel;
        const labelText = row.querySelector('.table-list__label-text');
        if (label && labelText) {
          const badge = document.createElement('span');
          badge.className = 'table-list__today';
          badge.textContent = label;
          labelText.after(badge);
        }
      }
    }

    customElements.define('table-list', TableList);
  }
  } catch(e) { console.error(e); }
})();

})();
